import { Brick, registerBrick } from 'olympe';
import { computeDestinationPoint, earthRadius } from 'geolib';

export default class ComputeDestinationPoint extends Brick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {number} latitude
     * @param {number} longitude
     * @param {number} altitudeM
     * @param {number} distanceM
     * @param {number} bearingDeg
     * @param {function(number)} setLatitude
     * @param {function(number)} setLongitude
     */
    update(context, [latitude, longitude, altitudeM, distanceM, bearingDeg], [setLatitude, setLongitude]) {
        const initialPoint = { latitude: latitude, longitude: longitude };
        const radius = earthRadius + altitudeM;
        const newPoint = computeDestinationPoint(initialPoint, distanceM, bearingDeg, radius);
        setLatitude(newPoint.latitude);
        setLongitude(newPoint.longitude);
    }
}

registerBrick('017c5553002abcfa25ab', ComputeDestinationPoint);
